import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=f3e3b4f0"
import script from "./LanguageSwitcher.js?vue&type=script&lang=js&external"
export * from "./LanguageSwitcher.js?vue&type=script&lang=js&external"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=f3e3b4f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports